import { ApiRequest, RequestMethod } from "../../request";

const URL = "/api/user/login";

export type LoginRequest = {
  username?: string;
  password?: string;
};

export type LoginResult = {
  success: boolean;
  errorMessage?: string;
};

export async function login({ username, password }: LoginRequest): Promise<LoginResult> {
  const apiRequest = new ApiRequest();
  apiRequest.setMethod(RequestMethod.POST);
  apiRequest.setUrl(URL);
  apiRequest.setJsonBody({ username, password });

  const response: any = await apiRequest.send();

  if (response.data?.authorized) return { success: true };
  return { success: false, errorMessage: response.data?.errorMessage };
}
